import alertUtils from './alertUtils'
import fileApi from '../components/api/fileApi'
// import customApi from '../components/api/customApi'

export default class fileUtils extends alertUtils {
  /**
   * 文件删除
   * @param fileList 文件集合
   * @param id  当前删除文件id
   */
  static fileDeleted(id, fileList) {
    fileList.forEach((item, index) => {
      if (item.id === id) {
        fileList.splice(index, 1)
      }
    })
    this.alertSuccess('文件删除成功', true)

    // fileApi.fileDeleted(id).then(response => {
    //   fileList.forEach((item, index) => {
    //     if (item.id === id) {
    //       fileList.splice(index, 1)
    //     }
    //   })
    //   this.alertSuccess('文件删除成功', true)
    // }).catch(e => {
    //   this.alertError('文件删除失败', true)
    // })
  }

  /**
   * 文件删除
   * @param fileList 文件集合
   * @param id  当前删除文件id
   */
  static imgDeleted(id, fileList) {
    fileList.forEach((item, index) => {
      if (item.id === id) {
        fileList.splice(index, 1)
      }
    })
    this.alertSuccess('图片删除成功', true)

    // fileApi.fileDeleted(id).then(response => {
    //   fileList.forEach((item, index) => {
    //     if (item.id === id) {
    //       fileList.splice(index, 1)
    //     }
    //   })
    //   this.alertSuccess('图片删除成功', true)
    // }).catch(e => {
    //   this.alertError('图片删除失败', true)
    // })
  }

  /**
   * 文件修改删除
   * @param id  当前删除文件id
   */
  static imgEditDelete(id) {
    fileApi
      .fileDeleted(id)
      .then(() => {})
      .catch(() => {
        this.alertError('图片删除失败', true)
      })
  }
}
